<template>
  <div class="hxifmnpage">
    <div class="view_page">
      <div class="page_head"></div>
      <div class="page_body">
        <div class="content">
          <div class="ct_text">
            <div
              style="display: flex;align-items: center;width:100%;height:100%;background:rgba(255,255,255,1);border-radius:16px;margin-top:1%;"
            >
             <!-- <img
                src="../../../resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png"
                alt
                class="kximg"
              />-->
              <img
                :src="user.avatar"
                alt
                class="kximg"
              />
              <div class="hxtext">
                 <span
                   style="font-family:PingFangSC-Regular;font-weight:400;color:rgba(0,0,0,1);font-size:4vw;"
                 >
                      {{user.nickname}}
                    </span>
                <span style="color:rgba(143,143,143,1);font-size:3.5vw;">{{user.phone}}</span>
                <span style="color:rgba(143,143,143,1);text-align: right;font-size:3.5vw;">{{user.addTime}}</span>
               <!-- <ul>
                  <li>

                  </li>
                  <li>
                    <span style="color:rgba(143,143,143,1)">{{user.phone}}</span>
                  </li>
                  <li style="text-align: right;">
                    <span style="color:rgba(143,143,143,1);">{{user.addTime}}</span>
                  </li>
                </ul>-->
              </div>
            </div>
          </div>
          <div class="ct_card" v-if="OrderInfo.length > 0">
            <div class="bjcard" v-for="(item,index) in OrderInfo" :key="index">
              <div class="cardrowhead">
                <img
                  src="../../../resource/img/qia.png"
                  alt
                  style="width: 3.9vw;height: 3vw;margin-right: 1vw;"
                />
                <span>{{item.name}}</span>
              </div>
              <div class="cardrowone">
                <table style="float:left;width:75%">
                  <tr style="text-align: center;">
                    <td style="width:10%">总数</td>
                    <td style="width:10%">已使用</td>
                    <td style="width:3%">剩余</td>
                  </tr>
                  <tr style="height:2px;"></tr>
                  <tr style="text-align: center;">
                    <td style="width:10%">{{item.buyNum}}</td>
                    <td style="width:10%">{{item.useNum}}</td>
                    <td style="width:3%">{{item.buyNum-item.useNum}}</td>
                  </tr>
                </table>
              </div>
              <div class="cardrowtwo" v-if="item.merchantExtendOrderUsedetailEntityList.length>0">
                <div class="cardrowhead">
                  <img
                    src="../../../resource/img/shijian.png"
                    alt
                    style="width: 3.9vw;height: 3vw;margin-right: 1vw;"
                  />
                <span>使用时间</span>
              </div>
                <div>
              <div v-for="(items,indexs) in item.merchantExtendOrderUsedetailEntityList" :key="indexs" >
                <span>
                  {{items.useTime}}
                </span>
              </div>
                </div>
              </div>
            </div>

          </div>
          <div class='null' v-else>
            <img class='pic'  src="../../../resource/img/pic_coupon_empty.png" />
            <div>暂无内容</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MerUnionmbHxinformation",
  data() {
    return {
      uid:null,
      merId:null,
      activityId: null,
      storeId:null,
      user:{},
      urlParam: {},//user activityId merId storeId
      OrderInfo: [],
    };
  },
  created() {
    if (this.$route.query.user) {
      this.user = JSON.parse(this.$route.query.user);
    }

    this.activityId = this.$route.query.activityId;
    this.merId = this.$route.query.merId;
    this.storeId = this.$route.query.storeId;
    this.uid = this.$route.query.uid;
    this.LmkOrderInfo();
  },
  methods: {
    LmkOrderInfo: function() {
      console.log("进入啦");
      let that = this;
      that.$axios
        .post(
          "/merchant/api/activity/merchant-market-product-order/user/list",
          that.$qs.stringify({
            storeId: that.storeId,
            activityId: that.activityId,
            uid: that.uid,
            merId:that.merId
          })
        )
        .then(response => {
          that.OrderInfo = response.data.data;
        })
        .catch(function(error) {
          //请求失败处理
          console.log(error);
        });
    }
  }
};
</script>
<style scoped>
  body{
    background: #f2f2f2;
  }
ul {
  list-style: none;
  padding: 0px;
}
li {
  margin-top: 2%;
}
.hxifmn {
  width: 100%;
  height: 100%;
}
.page_head {
  background-color: #5D4DA8;
  width: 100%;
  height: 25vh;
 /* background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");*/
}
.page_body {
  width: 100%;
  height: 60vh;
  background: rgba(242, 242, 242, 1);
  display: flex;
  justify-content: center;
}
.content {
  width: 92%;
  height: 80vh;
  border-radius: 20px 20px 20px 20px;
  position: relative;
  top: -16.95vh;
  /* flex-direction: column;  */
}
.ct_text {
  width: 100%;
  height: 18%;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  border: none;
}
.ct_card {
  width: 100%;
  min-height: 60%;
  margin-top: 5%;
  background-color: white;
  border-radius: 20px;
  border: none;
}
.kximg {
  width: 20%;
  height: 70%;
  padding-left: 4%;
  /*padding-top: 4%;*/
  float: left;
}
.hxtext {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 70%;
  height: 70%;
  padding-left: 2%;
  /*padding-top: 2%;*/
  float: left;
}
.bjcard {
  width: 90%;
  height: 45%;
  text-align: left;
  margin-left: 6%;
  margin-top: 3%;
  border-top: 1px solid #e5e5e5;
}
.cardrowone {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  width: 100%;
  height: 26%;
  margin-top: 3%;
  margin-left: 5vw;
}
.cardrowtwo {
  width: 100%;
  height: 40%;
  border-top: 0.3vw dashed dimgray;
  color: #bfbfbf;
  margin-top: 4vw;
}
.cardrowhead {
  align-items: center;
  display: flex;
  margin-top: 2%;
}
.null {
  margin-top: 15vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.null .pic {
  width: 200px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerTokerMerUserDetail.vue